import orgs from '@/API/services/orgs';


const getDefaultState = () => {
  return {
    clients: [],
    list: [],
    dash: {},
    organisations: [],
    apps: [],
  }
}

const state = getDefaultState()
const getters = {
  getDashAllApps: (state) => {
    state.apps = [];
    state.organisations?.forEach(org => {
      org.apps?.forEach((app) => {
        state.apps.push(app);
      })
    })
    return state.apps;
  }
};

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_ORGANISATIONS: (state, payload) => {
    state.organisations = payload;
  },
};

const actions = {
  resetDashboardState: ({ commit }) => {
    commit('RESET_STATE');
  },
  fetchOrganisationDashboard: async ({ commit }, payload) => {
    let orgsData = {}
    try {
      const { data } = await orgs.getAllOrganisationDashboard(payload);
      if (data) {
        orgsData = data;
      }
    } catch (err) {
      console.log('getdata err', err);
      return;
    }
    try {
      const { data } = await orgs.getAllRunning();
      if (data) {
        for (let i = 0; i < orgsData.length; i++) {
          const org = orgsData[i];
          if (data[org.clientHash]) {
            orgsData[i].runningApps = data[org.clientHash];
          }
        }
        await commit('SET_ORGANISATIONS', orgsData);
      }
    } catch (err) {
      console.log('getrunning err', err);
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
};
